/**
 * Created by Jie Gao on 2018-06-14.
 */
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {
    IPickAndClickConfig,
    PickAndClickController
} from "@nolimitcity/slot-game/bin/core/pickandclick/PickAndClickController";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DragonTribeGameModuleConfig} from "../../DragonTribeGameModuleConfig";
import {DragonTribeSoundConfig} from "../../DragonTribeSoundConfig";
import {DragonTribeParsedGameData} from "../../server/data/DragonTribeParsedGameData";
import {DragonTribeParsedInitData} from "../../server/data/DragonTribeParsedInitData";
import {FreespinFeatureEvent} from "../../winpresentation/fswildmeter/events/FreespinFeatureEvent";
import {DTFreespinIntroScreenView} from "./DTFreespinIntroScreenView";

export class DTFreespinIntroController extends PickAndClickController {
    private _gameView:DTFreespinIntroScreenView;
    private _isFreespinWon:boolean;
    private _isRestoreFreespin:boolean;
    private _playerFSSelection:number;
    private _fsLeft:number;

    constructor(config:IPickAndClickConfig) {
        super("PickNClick", config);
        this._gameView = <DTFreespinIntroScreenView>this._view;
        this._gameView.getFeatureStartSoundCallback(() => SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_INTRO));
        this._gameView.getFeatureStartSoundCallback(() => SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_INTRO_FIRE, -1));
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, FreespinFeatureEvent.METER_SHOWN, (event:GameEvent) => this.dispatchCompleteEvent());
    }

    protected parseFeatureGameData(data:DragonTribeParsedGameData):void {
        this._playerFSSelection = data.playerFSSelection;
        this._fsLeft = data.freespinsLeft;
    }

    protected calculateIsTriggered(data:DragonTribeParsedGameData):boolean {
        this._isFreespinWon = (data.nextMode.indexOf("FREESPIN") > -1 && data.mode.indexOf("FREESPIN") <= -1);
        return this._isFreespinWon || this._isRestoreFreespin;
    }

    protected calculateIsRestoreTriggered(data:DragonTribeParsedInitData):boolean {
        const isRestoreState:boolean = (data instanceof ParsedInitData) ? (<ParsedInitData>data).isRestoreState : false;
        this._isRestoreFreespin = isRestoreState && (data.mode.indexOf("FREESPIN") > -1);
        return this._isRestoreFreespin;
    }

    protected parseButtonConfigs(data:DragonTribeParsedGameData):any[] {
        return [1, 2]; // pick index: 1-Normal, 2-extreme.
    }

    protected onButtonClick(selectedIndex:number, autoClicked:boolean = false):void {
        // StarStruckGameModuleConfig.soundPlayer.playEffect(StarStruckSoundConfig.instance.BONUS_STAR_PICK);
        this._playerFSSelection = selectedIndex;
        this._gameView.disableButtons();
        // when autoClicked, send 3 and 4 instead of 1 and 2.
        autoClicked ? selectedIndex += 2 : selectedIndex;
        super.onButtonClick(selectedIndex, autoClicked);
        SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_SELECT);
    }

    //To Do: Look for better way of delay spin
    protected onCloseComplete():void {
        Logger.logDev(`Close PickAndClick ${this.moduleName}`);
        this.reset();
        this.showKeypad();
        SlotGame.winFieldController.showWinField();
        SlotGame.sound.stopEffect(DragonTribeSoundConfig.FS_INTRO_FIRE);
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, true));
        EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
        EventHandler.dispatchEvent(new GameEvent(FreespinFeatureEvent.SHOW_METER, this._isRestoreFreespin));
        DragonTribeGameModuleConfig.background.showFeatureLogo(this._playerFSSelection);
        this._isRestoreFreespin = false;

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    }

    protected playReplay():void {
        // autoSelected
        if(this._replayPlayerSelectionIndex > 2) {
            this._view.clickButton(this._replayPlayerSelectionIndex - 2 - 1, true);
        } else {
            this._view.clickButton(this._replayPlayerSelectionIndex - 1);
        }
    }

    protected dispatchCompleteEvent():void {
        EventHandler.dispatchEvent(new GameEvent(ScreenEvent.PICK_AND_CLICK_CLOSED, this._showWinPresentations));
    }

    protected close():void {
        SlotGame.keypad.setZeroBetSpinCounter(this._fsLeft);
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : this._serverData!.nextMode}));
        super.close();
    }
}